module.exports = __webpack_public_path__ + "static/media/om_beard_stiletto_diamond__v.2f8afa59.png";